export default {
    UNKNOWN: 'Unknown',
    BUS: 'Bus',
    TRAIN: 'Train',
    FERRY: 'Ferry',
    WALK: 'Walk',
    TUBE: 'Tube',
    TAXI: 'Taxi',
    METRO: 'Metro',
    TRAMLINK: 'Tramlink',
    PLATFORMCHANGE: 'PlatformChange',
    CHECKINTIME: 'CheckinTime',
    HOVERCRAFT: 'Hovercraft',
    TRANSFER: 'Transfer',
};



// WEBPACK FOOTER //
// ./src/app/modules/train/train-travel-modes.js